import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "next_btn" }

import { useRouter,useRoute } from "vue-router"
import { reactive, toRefs } from "vue"



export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const data = reactive({
    query: {} as any
})

const nextOne = async() => {
    let params = {
        modelCode: data.query.modelCode,
        modelName: data.query.modelName,
        selectServiceCode: data.query.selectServiceCode,
        guideId: data.query.guideId,
        projectcode: data.query.projectcode
    }
    toPath('./declaration', params)
}

const toPath = (path: string, params: any) => {
    router.push({
        path: path,
        query: params
    })
}

const getQueryData = () => {
    data.query = route.query
    console.log('data.query',data.query);
}

const init = () => {
    getQueryData()
}

init()


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"t6_breadCream\" data-v-78532aee><span data-v-78532aee>首页</span> <i data-v-78532aee>&gt;</i> <span data-v-78532aee>一件事</span> <i data-v-78532aee>&gt;</i> <span data-v-78532aee>告知承诺</span></div><div class=\"detail_content detail_content_bj\" data-v-78532aee><h1 style=\"color:#2185F2;\" data-v-78532aee>网上办事承诺书</h1><p class=\"detail_til\" style=\"font-weight:bold;\" data-v-78532aee>本单位（本人）自愿申请成为“网上办事大厅”用户，并郑重承诺如下：</p><p data-v-78532aee>本单位（本人）同意并接受《网上办事服务条款》所有内容。</p><p data-v-78532aee>在取得“网上办事大厅”合法用户身份后，应妥善管理用户密码及数字证书，严格遵循国家有关法规、政策及社保业务规范，保证提交业务数据及资料的真实、准确，并对有关资料妥善留存、归档，按业务审批机构要求提供审验。 </p><p data-v-78532aee>如违反以上承诺造成的不良后果，本单位（本人）行为将纳入不良诚信记录,并承担全部责任。</p><div class=\"etail_content_bt\" data-v-78532aee><span style=\"color:#E33232;\" data-v-78532aee>注：本承诺书经用户签署后立即生效，直至注销其用户资格为止。</span></div></div>", 2)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        onClick: nextOne,
        size: "large",
        color: "#4ACAB6",
        style: {"color":"#fff"}
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("跳转一件事办事", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})